import PageHeader from '../../components/PageHeader/PageHeader';
import Toolbar from '../../components/Toolbar/Toolbar';
import React, { useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { IoTrashOutline } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
import AgregarCalidad from './AgregarCalidad';
import EditarCalidad from './EditarCalidad';
import {urlApiProd} from '../utiles';

const Calidades = () => {
    const [dataCalidades, setDataCalidades] = useState([]);
    const firstRender = useRef(true);
    const [showAgregar, setShowAgregar] = useState(false);
    const [showEditar, setShowEditar] = useState(false);
    const [selected, setSelected] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const fetchData = async () => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        try {
            const calidadResponse = await fetch(`${urlApiProd}/calidades`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (calidadResponse.status === 401) {
                throw new Error('Unauthorized');
            }
            const calidadData = await calidadResponse.json();
            setDataCalidades(calidadData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (firstRender.current) {
            fetchData();
            firstRender.current = false;
        }
    }, []);

    useEffect(() => {
        if (Array.isArray(dataCalidades)) {
            const filtered = dataCalidades.filter((row) =>
                Object.values(row).some((value) =>
                    value.toString().toLowerCase().includes(filterText.toLowerCase())
                )
            );
            setFilteredData(filtered);
        }
    }, [dataCalidades, filterText]);

    const columns = [
        {
            name: 'Editar',
            cell: (row) => (
                <button className='btn btn-outline-primary' onClick={() => handleEditar(row)}>
                    <LuPencilLine />
                </button>
            ),
        },
        {
            name: 'Calidad',
            selector: row => row.calidad,
        },
        {
            name: 'Eliminar',
            cell: (row) => (
                <button
                    className='btn btn-outline-danger'
                    onClick={() => {
                        if (window.confirm('¿Estas seguro?')) {
                            handleEliminar(row.id_calidad);
                        }
                    }}
                >
                    <IoTrashOutline />
                </button>
            ),
            ignoreRowClick: true,
        },
    ];

    const handleAgregar = () => {
        setShowAgregar(true);
    };

    const handleEditar = (calidad) => {
        setSelected(calidad);
        setShowEditar(true);
    };

    const handleSaveEditar = (edited) => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        fetch(`${urlApiProd}/editarcalidad/${edited.id_calidad}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(edited),
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Error al actualizar datos');
            }
            return response.json();
        })
        .then(data => {
            alert('Datos actualizados exitosamente');
            fetchData();
        })
        .catch(error => {
            console.error('Error:', error);
        });
    };

    const handleCloseEditar = () => {
        setSelected(null);
        setShowEditar(false);
    };

    const handleEliminar = (idAEliminar) => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        fetch(`${urlApiProd}/eliminarcalidad/${idAEliminar}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
        .then(response => {
            if (response.ok) {
                alert('Datos Eliminados Correctamente.');
                fetchData();
            } else {
                alert('Error al intentar eliminar datos.');
            }
        })
        .catch(error => {
            console.error('Error de red:', error);
        });
    };

    return (
        <div className='container-fluid ui-page'>
            <PageHeader
                eyebrow="Registros"
                title="Calidades"
                descripcion="Catálogo de calidades disponibles para los productos."
                actions={
                    <button type="button" className="ui-btn ui-btn-primary" onClick={handleAgregar}>Agregar Calidad</button>
                }
            />
            <div className='card'>
                <div className='card-body mb-2'>
                    <Toolbar
                        left={
                            <input
                                type="text"
                                placeholder="Buscar..."
                                value={filterText}
                                onChange={(e) => setFilterText(e.target.value)}
                                className='form-control'
                            />
                        }
                    />
                    
                    {showAgregar && <AgregarCalidad cerrar={() => setShowAgregar(false)} />}
                    <div className="card">
                        <div className="card-body">
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                noHeader
                                responsive
                                pagination
                                highlightOnHover
                            />
                        </div>
                    </div>
                    {selected && showEditar && (
                        <EditarCalidad
                            calidad={selected}
                            cerrar={handleCloseEditar}
                            guardar={handleSaveEditar}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default Calidades